import { Container, Grid } from "@mui/material";
import { Links } from ".";
import Link from "../components/core/Link";
import "../styles/about.scss";

export function About() {
    return (
        <Container maxWidth={false} disableGutters className="About">
            <Grid
                container
                columnSpacing={4}
                justifyContent="center"
                alignItems="center"
                className="aboutContent"
            >
                <Grid item>
                    <div className="profilePictureContainer">
                        <img
                            className="profilePicture"
                            src="nolan_byrne_profile.jpg"
                            alt="Nolan Byrne"
                            width={256}
                            height={256}
                        />
                    </div>
                </Grid>
                <Grid
                    item
                    container
                    md={7}
                    direction="column"
                    justifyContent="center"
                >
                    <Grid item className="nameContainer">
                        <h1>
                            Hey, I'm{" "}
                            <span className="text-highlight">Nolan</span>
                        </h1>
                    </Grid>
                    <Grid item>
                        <h2>I build software that makes a difference</h2>
                    </Grid>
                    <Grid item>
                        <p>
                            I'm a full stack software engineer, technical
                            leader, and independent game developer with a
                            passion for creating incredible interactive
                            experiences. At
                            <Link
                                url="https://www.epic.com/about"
                                displayString=" Epic "
                            />
                            I own MyChart projects from concept to release,
                            setting technical direction, mentoring developers,
                            and delivering accessible healthcare software used
                            by millions of patients.
                        </p>
                    </Grid>
                    <Grid item>
                        <Links />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
}
